import { maritalOptions } from '../../../helpers';

export const PeronalDetailsHead = [
  { label: 'Details', width: 100, colSpan: 2 },
  { label: 'Client', minWidth: 136 },
  { label: 'Partner', minWidth: 136 },
];

export const DependentHead = [
  { label: 'Full Name', minWidth: 150 },
  { label: 'Date of Birth', minWidth: 150 },
  { label: 'Age', minWidth: 136 },
  { label: 'Gender', minWidth: 136 },
  { label: 'Institution', minWidth: 136 },
  { label: 'Start', minWidth: 136 },
  { label: 'End', minWidth: 136 },
  { label: 'Cost', minWidth: 136 },
  { label: '', minWidth: 50 },
];

export const dependentDefaultValues = {
  fullName: '',
  dateOfBirth: null,
  age: '',
  gender: {
    label: '',
    value: '',
  },
  schoolName: '',
  startDate: null,
  endDate: null,
  cost: '',
  show: true,
};

export const DEFAULT_VALUES = {
  details: [
    { details: 'Preferred Name', name: 'name', client: '', partner: '' },
    { details: 'Date of Birth', name: 'dob', client: null, partner: null, type: 'date', format: 'DD-MM-YYYY' },
    { details: 'Age', name: 'age', client: '', partner: '', disabled: true },
    { details: 'Email', name: 'email', client: '', partner: '' },
    { details: 'Nationality', name: 'nationality', client: '', partner: '' },
    { details: 'TIN Number', name: 'tin', client: '', partner: '' },
    { details: 'National Insurance Number', name: 'nino', client: '', partner: '' },
    { details: 'Occupation', name: 'occupation', client: '', partner: '' },
    { details: 'Employer/Company', name: 'employer', client: '', partner: '' },
    { details: 'Marital Status', name: 'marital', client: '', partner: '', type: 'select', options: maritalOptions },
    { details: 'Telephone Number', name: 'phone', client: '', partner: '' },
    { details: 'Mobile Number', name: 'mobile', client: '', partner: '' },
    { subheading: 'Residential Address', details: 'Address Line 1', name: 'addressLine1', client: '', partner: '' },
    { details: 'Address Line 2', name: 'addressLine2', client: '', partner: '' },
    { details: 'City', name: 'city', client: '', partner: '' },
    { details: 'Country', name: 'country', client: '', partner: '' },
    { details: 'Zip code', name: 'pincode', client: '', partner: '' },
  ],
  dependents: [dependentDefaultValues],
};
